import { takeLeading } from "@redux-saga/core/effects";
import FileSaver from "file-saver";
import { put, select } from "redux-saga/effects";
import videoJobSelector from "selectors/videoJob";

function* execute() {
    const videoJob: sage.model.IVideoJob | null = yield select(
        videoJobSelector
    );
    if (!videoJob || !videoJob.rendahand_file_data) {
        return;
    }
    const fileData = videoJob.rendahand_file_data;
    const blob = new Blob([JSON.stringify(fileData)], {
        type: "text/plain;charset=utf-8",
    });
    FileSaver.saveAs(blob, "animation.rendahand");
    yield put({
        type: "com.sage.actions.createAnimation.IHasDownloaded",
        hasDownloaded: true,
    } as sage.actions.createAnimation.IHasDownloaded);
}

export default function* saga(): Generator {
    yield takeLeading(
        "com.sage.actions.createAnimation.IDownloadVideoJobAnimation",
        execute
    );
}
